function leptospirose (){
    return{
            "games":[
          {
                "informs":[
                    {
                        "text":"Os principais reservatórios da Leptospira são o rato de esgoto Rattus <i>norvegicus</i>, rato de telhado Rattus <i>rattus</i> e os camundongos Mus <i>musculus</i>.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leptospirose/1.png"
                    },
                    {
                        "text":"Esses animais se infectam, porém não desenvolvem a doença, albergam a leptospira nos rins, eliminando-a viva no meio ambiente juntamente com a urina.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leptospirose/1.png"
                    },
                    {
                        "text":"Outros reservatórios de importância são: caninos, suínos, bovinos, equinos, ovinos e caprinos. Os seres humanos são apenas hospedeiros acidentais e terminais dentro da cadeia de transmissão.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leptospirose/1.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/lepto/1.jpg"
          },
          {
            "informs":[
                {
                    "text":"O agente causador da Leptospirose é uma bactéria helicoidal do gênero Leptospira, do qual se conhecem atualmente 14 espécies patogênicas, sendo a mais importante a L. <i>interrogans</i>.",
                    "title":"Quem causa a doença?",
                    "image":"images/games/informs/leptospirose/2.png"
                },
                {
                    "text":"O agente causador da leptospirose pode sobreviver no ambiente durante semanas ou até meses, dependendo das condições do ambiente (temperatura, umidade, lama ou águas de superfície).",
                    "title":"Quem causa a doença?",
                    "image":"images/games/informs/leptospirose/2.png"
                },
                {
                    "text":"Porém, é sensível a desinfetantes comuns, como o hipoclorito de sódio, presente na água sanitária.",
                    "title":"Quem causa a doença?",
                    "image":"images/games/informs/leptospirose/2.png"
                }
            ],
            "pathImageGame":"midias/images/games/puzzles/lepto/2.jpg"
        },
        {
            "informs":[
                {
                    "text":"A maioria dos infectados não apresenta sintomas da doença ou desenvolve manifestações discretas que, quando ocorrem, surgem de 2 a 30 dias após a infecção, pode ser confundida com virose.",
                    "title":"Quais os sintomas da doença?",
                    "image":"images/games/informs/leptospirose/3.png"
                },
                {
                    "text":"Os sintomas iniciais são: febre, dor de cabeça e muscular na região lombar e panturrilhas, falta de apetite, náuseas e vômitos. Podendo regredir em 3 a 7 dias, sem deixar sequelas.",
                    "title":"Quais os sintomas da doença?",
                    "image":"images/games/informs/leptospirose/3.png"
                },
                {
                    "text":"Na forma grave é caracterizada pelos sintomas: icterícia (amarelamento da pele), insuficiência renal e hemorragias.",
                    "title":"Quais os sintomas da doença?",
                    "image":"images/games/informs/leptospirose/3.png"
                }
            ],
            "pathImageGame":"midias/images/games/puzzles/lepto/3.jpg"
        },
        {
            
            "informs":[
                {
                    "text":"A transmissão da doença ocorre pelo contato do homem com as leptospiras da urina de animais infectados.",
                    "title":"Como a doença é transmitida?",
                    "image":"images/games/informs/leptospirose/4.png"
                },
                {
                    "text":"A bactéria penetra na pele com lesões, em mucosas ou na pele íntegra imersa por longo tempo em água contaminada.",
                    "title":"Como a doença é transmitida?",
                    "image":"images/games/informs/leptospirose/4.png"
                },
                {
                    "text":"Pode ocorrer transmissão (raramente) pelo contato com sangue, tecidos de animais infectados, acidentes laboratoriais e ingestão de água/ alimentos contaminados.",
                    "title":"Como a doença é transmitida?",
                    "image":"images/games/informs/leptospirose/4.png"
                },
                {
                    "text":"Entre pessoas a transmissão é rara e ocorre quando há contato com fluidos corporais e tecidos infectados.",
                    "title":"Como a doença é transmitida?",
                    "image":"images/games/informs/leptospirose/4.png"
                }
            ],
            "pathImageGame":"midias/images/games/puzzles/lepto/4.jpg"
        },
        {
            "informs":[
                {
                   "text":"Evitar o contato com água ou lama que possam estar contaminados pela urina de rato (nas enchentes, por exemplo). Em casos de exposição é importante usar botas, luvas e sacos plásticos para diminuir a área exposta.",
                   "title":"Como fazer a prevenção?",
                   "image":"images/games/informs/leptospirose/5.png"
                },
                {
                   "text":"Trabalhadores de limpeza de lama, entulhos e desentupimento de esgoto devem usar botas e luvas de borracha.",
                   "title":"Como fazer a prevenção?",
                   "image":"images/games/informs/leptospirose/5.png"
                },
                {
                   "text":"O controle de roedores, medidas ligadas ao meio ambiente como, obras de saneamento básico (abastecimento de água, lixo e esgoto) e melhorias nas habitações humanas também ajudam na prevenção.",
                   "title":"Como fazer a prevenção?",
                   "image":"images/games/informs/leptospirose/5.png"
                }
            ]
            ,
                "pathImageGame":"midias/images/games/puzzles/lepto/5.jpg"
            }
        ]
    };
}

export{leptospirose};